export default __webpack_public_path__ + "static/restaurant-cafe-9d0274b530dfcb5aa6f7ab7f4045c9ba.png";